export default __webpack_public_path__ + "static/media/followone_cat_feature_auto.d294cdcc.jpg";